export const paramsInputsStyle = { display: 'flex', flexDirection: 'column', gap: 10 };
